export const DATA_TABLE_DEFAULT_PAGE_SIZE = 20;
export const DATA_TABLE_PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;
